export default function TestCardsTable() {
    const cards = [
        { type: 'VISA', color: 'text-blue-600', cvv: '3-digit', numbers: ['4111 1111 1111 1111', '4012 8888 8888 1881', '4222 2222 2222 2222'] },
        { type: '3DS', color: 'text-blue-600', cvv: '3-digit', numbers: ['4000000000002503'] },
        { type: 'MASTERCARD', color: 'text-orange-600', cvv: '3-digit', numbers: ['5555 5555 5555 4444', '5105 1051 0510 5100', '5432 1234 5678 9876'] },
        { type: 'AMERICAN EXPRESS', color: 'text-green-600', cvv: '4-digit', numbers: ['3782 822463 10005', '3714 496353 98431', '3411 726629 87061'] },
        { type: 'DISCOVER', color: 'text-purple-600', cvv: '3-digit', numbers: ['6011 0000 0000 0004', '6011 1111 1111 1117', '6011 0000 0000 0009'] },
        { type: 'DINERS CLUB', color: 'text-gray-600', cvv: '3-digit', numbers: ['3056 9309 0259 04', '3600 6666 3333 44', '3852 0000 0232 37'] },
        { type: 'JCB', color: 'text-red-600', cvv: '3-digit', numbers: ['3530 1113 3330 0000', '3566 0020 2036 0505'] },
        { type: 'UNION PAY', color: 'text-indigo-600', cvv: '3-digit', numbers: ['6250 9460 0000 0016', '6250 9470 0000 0014', '6222 8212 3456 0017'] },
    ];

    return (
        <div className="w-full max-w-4xl bg-white rounded-lg shadow-sm border border-gray-200 mx-auto p-8">
            <div className="text-center mb-6">
                <h2 className="text-2xl font-semibold text-gray-900 mb-2">Test Cards</h2>
                <p className="text-gray-600">Use these test card numbers for testing payments</p>
            </div>
            <div className="bg-gray-50 rounded-lg p-6">
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b border-gray-200">
                                <th className="text-left py-3 px-4 font-medium text-gray-700">Card Type</th>
                                <th className="text-left py-3 px-4 font-medium text-gray-700">Card Number</th>
                                <th className="text-left py-3 px-4 font-medium text-gray-700">Expiration</th>
                                <th className="text-left py-3 px-4 font-medium text-gray-700">CVV/CID</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600">
                            {cards.flatMap((card, ci) =>
                                card.numbers.map((num, ni) => (
                                    <tr key={`${ci}-${ni}`} className={ci < cards.length - 1 || ni < card.numbers.length - 1 ? 'border-b border-gray-100' : ''}>
                                        <td className={`py-3 px-4 ${ni === 0 ? `font-medium ${card.color}` : ''}`}>{ni === 0 ? card.type : ''}</td>
                                        <td className="py-3 px-4 font-mono text-gray-900">{num}</td>
                                        <td className="py-3 px-4">Any future date</td>
                                        <td className="py-3 px-4">Any {card.cvv}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-6 mt-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">APM Test Credentials</h3>
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="border-b border-gray-200">
                                <th className="text-left py-3 px-4 font-medium text-gray-700">Provider</th>
                                <th className="text-left py-3 px-4 font-medium text-gray-700">Field</th>
                                <th className="text-left py-3 px-4 font-medium text-gray-700">Value</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600">
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4 font-medium text-yellow-600" rowSpan={2}>PAYPAL</td>
                                <td className="py-3 px-4">Email</td>
                                <td className="py-3 px-4 font-mono text-gray-900">paypaltest@tnsi.com</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4">Password</td>
                                <td className="py-3 px-4 font-mono text-gray-900">paypaltest123</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4 font-medium text-green-600">PIX</td>
                                <td className="py-3 px-4">Document ID</td>
                                <td className="py-3 px-4 font-mono text-gray-900">11934254096</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4 font-medium text-pink-600" rowSpan={2}>KLARNA</td>
                                <td className="py-3 px-4">Phone Number</td>
                                <td className="py-3 px-4 font-mono text-gray-900">+13106683312</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4">PIN</td>
                                <td className="py-3 px-4 font-mono text-gray-900">123456</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4 font-medium text-blue-700" rowSpan={3}>TRUSTLY_NL</td>
                                <td className="py-3 px-4">Description</td>
                                <td className="py-3 px-4 text-gray-900">iDeal / Wero (via Trustly)</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4">Merchant Username</td>
                                <td className="py-3 px-4 font-mono text-gray-900">optty_test</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4">Merchant Password</td>
                                <td className="py-3 px-4 font-mono text-gray-900">fce58372-bbad-447c-990b-c54703c00a89</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4 font-medium text-blue-700" rowSpan={3}>TRUSTLY_EU</td>
                                <td className="py-3 px-4">Description</td>
                                <td className="py-3 px-4 text-gray-900">Trustly (direct)</td>
                            </tr>
                            <tr className="border-b border-gray-100">
                                <td className="py-3 px-4">Merchant Username</td>
                                <td className="py-3 px-4 font-mono text-gray-900">optty_test</td>
                            </tr>
                            <tr>
                                <td className="py-3 px-4">Merchant Password</td>
                                <td className="py-3 px-4 font-mono text-gray-900">fce58372-bbad-447c-990b-c54703c00a89</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
